import { render, staticRenderFns } from "./com-upload-file.vue?vue&type=template&id=48c71089"
import script from "./com-upload-file.vue?vue&type=script&lang=js"
export * from "./com-upload-file.vue?vue&type=script&lang=js"
import style0 from "./com-upload-file.vue?vue&type=style&index=0&id=48c71089&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\.jenkins\\workspace\\tplt.10ndata.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48c71089')) {
      api.createRecord('48c71089', component.options)
    } else {
      api.reload('48c71089', component.options)
    }
    module.hot.accept("./com-upload-file.vue?vue&type=template&id=48c71089", function () {
      api.rerender('48c71089', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/com-upload-file/com-upload-file.vue"
export default component.exports